<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">基本信息</div>
        <div class="wt-tab-info-content wt-tab-base">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">社区名称：</span>
            <span class="wt-tab-base-value">{{ detailFormData.communityName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点名称：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">站点位置：</span>
            <span class="wt-tab-base-value">{{ detailFormData.address }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">物业总公司：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name1 }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">物业分公司：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name2 }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">项目部：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name3 }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">是否开通投递功能：</span>
            <span class="wt-tab-base-value">{{ detailFormData.isDeliveryEnabled == 0 ? '是' : '否' }}</span>
          </div>
        </div>
      </div>
      <div class="wt-tab-info-card">
          <div class="wt-tab-info-title">站长信息</div>
          <div class="wt-tab-info-content wt-tab-base">
            <wt-form-table :form.sync="siteManageData" style="width: 100%;"></wt-form-table>
          </div>
        </div>
      <!-- tab -->
      <div class="wt-tab-info-card">
        <el-tabs v-model="activeTabName" type="card">
          <el-tab-pane label="投递记录" name="1"></el-tab-pane>
          <el-tab-pane label="商品补货" name="2"></el-tab-pane>
          <el-tab-pane label="兑换记录" name="3"></el-tab-pane>
          <el-tab-pane label="出库记录" name="4"></el-tab-pane>
          <el-tab-pane label="耗材补货" name="5"></el-tab-pane>
          <el-tab-pane label="其他类型记录" name="6"></el-tab-pane>
          <el-tab-pane label="可回收物库存" name="7"></el-tab-pane>
          <el-tab-pane label="其他类型库存" name="8"></el-tab-pane>
        </el-tabs>
        <SiteDeliveryView v-if="activeTabName === '1'" :hideBtn="true" :siteId="detailData.id"></SiteDeliveryView>
        <SiteGoodsViewTab v-if="activeTabName === '2'" :siteId="detailData.id"></SiteGoodsViewTab>
        <SiteGoodsExchangeViewTab v-if="activeTabName === '3'" :siteId="detailData.id"></SiteGoodsExchangeViewTab>
        <SiteOutboundViewTab v-if="activeTabName === '4'" :siteId="detailData.id"></SiteOutboundViewTab>
        <SiteConsumablesViewTab v-if="activeTabName === '5'" :siteId="detailData.id"></SiteConsumablesViewTab>
        <SiteOtherDeliveryViewTab v-if="activeTabName === '6'" :siteId="detailData.id"></SiteOtherDeliveryViewTab>
        <SiteRecycleViewTab v-if="activeTabName === '7'" :siteId="detailData.id"></SiteRecycleViewTab>
        <SiteOtherInventoryViewTab v-if="activeTabName === '8'" :siteId="detailData.id"></SiteOtherInventoryViewTab>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteIndexViewPage',
  props: ['component-type', 'detailData'],
  isAutoComponent: true,
  data() {
    return {
      activeTabName: '1',
      siteForm: {
        hidePage: true,
        noRequest: true,
        isFormLoading: false,
        formComponent: {},
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '物品名称', key: 'name', type: 'text' },
          { name: '申请出库（重量）', key: 'count', type: 'text' },
          { name: '出库当日（重量）', key: 'countCurrent', type: 'text' },
          { name: '实际出库（重量）', key: 'countReal', type: 'text' }],
        formTableButtonsData: [{ name: '纠错', key: 'CHECK', action: 'CHECK', className: 'primary', hidden: false }],
        formResult: { list: [] },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: true }
      },
      detailFormButtons: {
        title: '站点详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      siteManageData: {
        hidePage: true,
        noRequest: true,
        formInputsData: [],
        formButtonsData: [],
        formComponent: {},
        formTableData: [
          { name: '站长姓名', key: 'name', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' }],
        formTableButtonsData: [],
        formResult: { list: [] },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      },
      detailFormData: {}
    }
  },
  mounted() {
    this.detailFormData = JSON.parse(JSON.stringify(this.detailData))
    this.siteManageData.formResult.list = this.detailFormData.employeesList ? this.detailFormData.employeesList : []
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'CHECK') { // 纠错
          this.formData = JSON.parse(JSON.stringify(data.row))
          this.dialogVisible = true
        }
      }
    }
  }
}
</script>
<style scoped>
  .wt-tab-info-card {
    background: #FFFFFF;
    .wt-tab-base-label {
      width: 130px !important;
    }
  }
</style>
